import { Capacitor } from '@capacitor/core';

export function isNativeApp() {
  try {
    return Boolean(Capacitor?.isNativePlatform?.());
  } catch (_error) {
    return false;
  }
}

export const IS_NATIVE_APP = isNativeApp();
